export default "__VITE_ASSET__bf059ae1__"